module.exports = __webpack_public_path__ + "78093a2bdd6ce031ea7581ba0d37bfc1.png";